export default class TemplateBreakdownPointsModel {
  public groupId: string;
  public averagePoints: number;
  public highestPoints: number;
}
